import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UserManagedButtonAreaComponent.css';
import { Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import {
  setResetUserList, executePasswordReset, executeFileDownload, setPasswordResetPopFlg,
} from '../../actions/UserManagedAction';
import {
  setSystemLodingFLg, setConfirmPopFlg, setErrorMessage,
  setInfoMessage, setPopMessage, setOnClickYesFunction, setOnClickNoFunction,
} from '../../actions/CommonAction';
import validator from '../../../common/validator';
import { getMessage } from '../../../common/util';
import { INFO } from '../../../common/message';
import {
  INPUT,
} from '../../../common/const';
import MyIcon from '../common/MyIcon';

class UserManagedButtonAreaComponent extends Component {
  /**
   * CSVファイルダウンロードボタン押下時の処理
   */
  downloadFile = async () => {
    const {
      executeFileDownloadAct,
      setSystemLodingFlgAct,
    } = this.props;
    // CSVファイルダウンロードAPI実行
    setSystemLodingFlgAct(true);
    await executeFileDownloadAct();
    setSystemLodingFlgAct(false);
  }

  /**
   * パスワード初期化ボタン押下時の処理
   */
  resetPassword = () => {
    const {
      resetUserList,
      setPasswordResetPopFlgAct,
      setErrorMessageAct,
    } = this.props;
    // パスワード初期化対象ユーザー下限チェック
    const msgs = [];
    validator.checkLeast(INPUT.USERMANAGED.RESET_USER_LIST, 1, resetUserList, msgs);
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      setErrorMessageAct(getMessage(msgs));
      return;
    }
    setErrorMessageAct();
    setPasswordResetPopFlgAct(true);
  }

  /**
 * 確認POPUP「はい」選択時の処理
 */
  onClickYesButton = async () => {
    const {
      resetUserList,
      setInfoMessageAct,
      setResetUserListAct,
      setSystemLodingFlgAct,
      executePasswordResetAct,
    } = this.props;
    setSystemLodingFlgAct(true);
    // ユーザーパスワード初期化変更API呼出し
    if (await executePasswordResetAct(resetUserList)) {
      // 正常応答が返されたら変更完了メッセージを表示
      setResetUserListAct([]);
      setInfoMessageAct(INFO.I04004);
    }
    setSystemLodingFlgAct(false);
  }

  render() {
    const {
      resetUserList,
    } = this.props;
    return (
      <>
        <div className="usermanagedbutton">
          <div className="button">
            <Button
              variant="contained"
              color="primary"
              startIcon={<Refresh />}
              className={resetUserList === null || resetUserList.length <= 0 ? 'buttonDisabled' : ''}
              onClick={this.resetPassword}
              disabled={
                !resetUserList
                || resetUserList.length === 0
              }
            >
              パスワードリセット
            </Button>
            <div className="balloon-top balloon">
              <div className="triangle">
                <div />
              </div>
              <div className="bubble">
                ユーザー情報を全件出力する
              </div>
            </div>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<MyIcon className="downloadIcon" type="download" />}
              onClick={this.downloadFile}
            >
              CSVダウンロード
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    userResultList: state.usermanaged.userResultList,
    resetUserList: state.usermanaged.resetUserList,
  }),
  (dispatch) => ({
    setResetUserListAct: (str) => dispatch(setResetUserList(str)),
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setConfirmPopFlgAct: (bool) => dispatch(setConfirmPopFlg(bool)),
    setErrorMessageAct: (str) => dispatch(setErrorMessage(str)),
    setInfoMessageAct: (str) => dispatch(setInfoMessage(str)),
    setPopMessageAct: (str) => dispatch(setPopMessage(str)),
    setPasswordResetPopFlgAct: (bool) => dispatch(setPasswordResetPopFlg(bool)),
    setOnClickYesFunctionAct: (func) => dispatch(setOnClickYesFunction(func)),
    setOnClickNoFunctionAct: (func) => dispatch(setOnClickNoFunction(func)),
    executePasswordResetAct: (userList) => dispatch(executePasswordReset(userList)),
    executeFileDownloadAct: () => dispatch(executeFileDownload()),
  }),
)(UserManagedButtonAreaComponent);
